var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesDistanceLimitation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 88,
    viewBox: "0 0 90 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L56.544 0 88 0 88 88 0 88z",
    transform: "translate(-444 -2378) translate(444 2378)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E4E9F2",
    d: "M38.064 39L51.058 31.577 55.416 29.088 55.416 0 38.064 9.888zM3.312 9.888L3.312 39 20.688 29.088 20.688 0 3.312 9.888",
    transform: "translate(-444 -2378) translate(444 2378) translate(12 16) translate(6 14.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CEE0",
    d: "M20.688 0L20.688 29.088 38.064 39 38.064 9.888 20.688 0",
    transform: "translate(-444 -2378) translate(444 2378) translate(12 16) translate(6 14.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#475B7F",
    d: "M47.736 21.12L46.392 24.24 40.68 37.488 43.632 35.832 49.344 22.56 50.664 19.464 55.416 8.4 55.416 3.24 47.736 21.12 53.283 11.715M33.168 7.08c-.288 1.584-1.8 9.096-6 13.368l1.848 1.056c3.912-4.272 5.52-10.776 6.024-13.368L33.168 7.08M20.664 23.4c-6.84.168-9.384 7.296-9.84 11.328l2.304-1.32c.672-2.808 2.52-7.848 7.584-7.968 2.712-.048 4.92-1.008 6.744-2.472l-1.944-1.104c-1.368.936-2.976 1.512-4.848 1.536",
    transform: "translate(-444 -2378) translate(444 2378) translate(12 16) translate(6 14.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M38.064 26.64l-9.048-5.136-1.848-1.056-5.976-3.432c-.312-.144-.696-.144-1.008 0L3.312 26.64v2.352l17.376-9.912 4.824 2.784 1.944 1.104 10.104 5.736c.312.192.696.192.984 0l7.848-4.464 1.344-3.12-9.672 5.52",
    transform: "translate(-444 -2378) translate(444 2378) translate(12 16) translate(6 14.4)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6173FE",
    d: "M22.852 13.595H1.479c-.812 0-1.479.66-1.479 1.448v4.802c0 6.55 5.38 11.925 11.992 12.01 6.785.101 12.339-5.575 12.339-12.283v-4.53c0-.787-.667-1.447-1.479-1.447",
    transform: "translate(-444 -2378) translate(444 2378) translate(13 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M12.165.738C6.641.738 2.133 5.21 2.133 10.657v2.938H5.35v-2.938c0-3.698 3.059-6.737 6.814-6.737 3.756 0 6.816 3.039 6.816 6.737v2.938h3.218v-2.938C22.2 5.21 17.69.738 12.165.738",
    transform: "translate(-444 -2378) translate(444 2378) translate(13 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7AFFF",
    d: "M14.137 20.074c0-1.075-.884-1.95-1.972-1.95-1.087 0-1.971.875-1.971 1.95 0 .63.304 1.175.782 1.52l-.783 4.27h3.944l-.768-4.27c.464-.345.768-.89.768-1.52",
    transform: "translate(-444 -2378) translate(444 2378) translate(13 11)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesDistanceLimitation);
export default __webpack_public_path__ + "static/media/features-distance-limitation.de4035f8.svg";
export { ForwardRef as ReactComponent };